import Stack from '@mui/material/Stack'
import React from 'react'

import { HHFormTextField } from 'components/form-fields/v5'
import T from 'T'

import { EXCEPTION_FORM_FIELD } from '../constants'

import type { ExceptionFormValues } from '../constants'
import type { Control } from 'react-hook-form'

// Set location: editable latitude / longitude. (The "Previous location" reference shown on
// the card is read-only history and stays on the card, not the edit form.)
type LocationFieldsProps = {
  control: Control<ExceptionFormValues>
}

const LocationFields: React.FC<LocationFieldsProps> = ({ control }) => (
  <Stack direction="row" gap={1}>
    <HHFormTextField fullWidth control={control} deprecatedLabel={false} label={T.LATITUDE} name={EXCEPTION_FORM_FIELD.LATITUDE} />
    <HHFormTextField fullWidth control={control} deprecatedLabel={false} label={T.LONGITUDE} name={EXCEPTION_FORM_FIELD.LONGITUDE} />
  </Stack>
)

export default LocationFields
